export enum Accessor {
  Index = 'index',
  CompanyName = 'companyName',
  CreditLimit = 'creditLimit',
  Status = 'status',
  Notes = 'notes',
  BillingAddresses = 'billingAddresses',
}
